<template>
  <IframeCmp type="117" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

// const getDashboardParams =

export default {
  // 客户总览明细
  name: 'DailyCollectionReceivableReportCustomer',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>

<style scoped></style>
